import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, Input, Tooltip } from 'component-library';
import { useEffect, useMemo, useState } from 'react';
import { ConversionSpeed } from '../../../../helpers/Custom';
import { ValidPositiveNumber } from '../../../../helpers/Validation';
import { BoatModel } from '../../../../models/ApiModels';

type Props = {
  boatModel: BoatModel;
  editMode: boolean;
  setUpdateBoatModel: (boatModel: BoatModel) => void;
  updateBoatModel: BoatModel;
  isKnots: boolean;
  setIsKnots: (value: boolean) => void;
  setIsValid: (value: boolean) => void;
};

function CruisingSpeed(props: Props) {
  const [cruisingSpeed, setCruisingSpeed] = useState<number>(props.updateBoatModel.cruisingSpeed || 0);

  const validCruisingSpeed = useMemo(
    () => ValidPositiveNumber(props.updateBoatModel.cruisingSpeed) || props.updateBoatModel.cruisingSpeed === 0,
    [props.updateBoatModel.cruisingSpeed]
  );
  function CheckIsKnots(id: string) {
    if (id === 'kn') {
      props.setIsKnots(true);
      return props.isKnots;
    } else if (id === 'mph') {
      props.setIsKnots(false);
      return props.isKnots;
    }
  }
  useEffect(() => {
    if (props.updateBoatModel.cruisingSpeed !== undefined)
      setCruisingSpeed(ConversionSpeed(props.updateBoatModel.cruisingSpeed, props.isKnots));
  }, [props.updateBoatModel.cruisingSpeed, props.isKnots]);

  useEffect(() => {
    if (validCruisingSpeed) props.setIsValid(true);
    else props.setIsValid(false);
  }, [validCruisingSpeed]);

  return (
    <div className='flex justify-between py-5 items-center'>
      <span className='flex gap-1'>
        Cruising speed
        <Tooltip description='A speed that is usually somewhat below maximum, that is comfortable and economical for longer distances.' />
      </span>
      {props.editMode ? (
        <div className='flex gap-2'>
          <Input
            size='Small'
            type='number'
            value={cruisingSpeed === 0 ? '' : cruisingSpeed}
            onChange={(input: number) => setCruisingSpeed(input)}
            onBlur={(input: number) => {
              props.updateBoatModel.cruisingSpeed = ConversionSpeed(input, props.isKnots);
              props.setUpdateBoatModel({ ...props.updateBoatModel });
            }}
          />
          <Dropdown
            size='Medium'
            label=''
            optionsData={[
              { id: 'kn', value: 'Kn' },
              { id: 'mph', value: 'Mph' },
            ]}
            placeholder='Kn'
            value={props.isKnots ? 'Kn' : 'Mph'}
            onValueChosen={(id: string) => CheckIsKnots(id)}
          />
        </div>
      ) : (
        <span className={`${!props.boatModel.cruisingSpeed && 'italic'}`}>
          {props.boatModel.cruisingSpeed ? (
            `${ConversionSpeed(props.boatModel.cruisingSpeed, props.isKnots, true)}`
          ) : (
            <div className='text-warning-100'>
              <FontAwesomeIcon icon={faTriangleExclamation} /> <span className='text-gray-40'>Not added</span>
            </div>
          )}
        </span>
      )}
    </div>
  );
}

export default CruisingSpeed;
